import React from 'react';

const DateTime = new Date().getFullYear().toString();

const Year = () =>
  <span>{DateTime}</span>

export default Year;
